<!-- Topics Directory -->

<template>
  <div>
    <h1>Welcome, {{user.attributes.name}}</h1>
  </div>
</template>

<script>

export default {
  name: 'Feed',
  data() {
    return {
      user: { attributes: {} },
    };
  },
};
</script>
